///<reference path='../../typings/index.d.ts' />

module agi.expressions.card.layer {
    import EventBus = agi.expressions.event.EventBus;
    import Event = agi.expressions.event.Event;
    export class PixiLayer extends PIXI.Container{
        
        protected isPlaying:boolean = false;
        protected eventBus:EventBus = EventBus.getInstance();
        public container:PIXI.Container = this;
        
        constructor(){
            super();
        }
        
        public init(options?:any):void{
            //Create the layer
        }

        public preInit():void {
            // Used to create objects before init
        }
        
        public animate(deltaTime?:number):void{
            //Override with animations within the container
        }
        
        public transition(options?:any):void{
            //Work that needs to be done when transitioning
            //the container
        }

        public transitionFinished(options?:any):void{
            //Work that needs to be done when transitioning
            //the container is finished
        }
        
        public hide():void{
            //Hide the container
            this.visible = false;
        }

        public reset():void {
            //Call when the layer needs to be reset.
        }
        
        //Make sure your container width and height 
        //are correct before calling these set Pivots.
        
        public setPivot(point?:PIXI.Point):void{
            this.pivot = point;
        }
        
        public setPivotCenter(point?:PIXI.Point):void{
            if (point){
                this.pivot = point;
            }
            else {
                this.pivot.x = this.width / 2;
                this.pivot.y = this.height / 2;
            }
        }
        
        public setPivotUpperLeft():void{
            this.pivot.x = 0;
            this.pivot.y = 0;
        }
        
        public setPivotBottomLeft(height?:number):void{
            this.pivot.x = 0;
            (height) ? this.pivot.y = height : this.pivot.y = this.height;
        }
        
        public setPivotUpperRight(width?:number):void{
            (width) ? this.pivot.x = width : this.pivot.x = this.width;
            this.pivot.y = 0;
        }
        
        public setPivotBottomRight(width?:number, height?:number):void{
            (width) ? this.pivot.x = width : this.pivot.x = this.width;
            (height) ? this.pivot.y = height : this.pivot.y = this.height;
        }
    }
}